import React, { useEffect, useRef, useState } from 'react';
import { speakSuccess } from '../utils/tts';
import { vibrateSuccess } from '../utils/haptic';

interface Props {
    prenom: string;
    conteneur: string;
    onRetour: () => void;
}

const ConfirmationScreen: React.FC<Props> = ({ prenom, conteneur, onRetour }) => {
    const [count, setCount] = useState(5);

    // Le retour est lu au moment du declenchement, pas capture au montage : le parent recree
    // cette fonction a chaque rendu, et la mettre en dependance relancerait le compte a rebours
    // depuis 5 a chaque fois — l'ecran ne se fermerait jamais.
    const retourRef = useRef(onRetour);
    retourRef.current = onRetour;

    useEffect(() => {
        vibrateSuccess();
        speakSuccess(prenom);
        const timer = setInterval(() => {
            setCount(c => {
                if (c <= 1) { clearInterval(timer); retourRef.current(); return 0; }
                return c - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [prenom]);

    return (
        <div style={styles.screen}>
            {/* Cercle animé */}
            <div style={styles.circle}>
                <span style={{ fontSize: 72 }}>🎉</span>
            </div>

            <h1 style={styles.title}>MISSION TERMINÉE !</h1>
            <p style={styles.sub}>Bravo {prenom} !</p>

            <div style={styles.conteneurBox}>
                <p style={styles.conteneurLabel}>CONTENEUR LIVRÉ</p>
                <p style={styles.conteneurNum}>{conteneur}</p>
            </div>

            <p style={styles.autoReturn}>Retour automatique dans {count}s...</p>

            <button onClick={onRetour} style={styles.btn}>
                🏠 RETOUR À L'ACCUEIL
            </button>
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    screen: {
        minHeight: '100vh', background: '#052e16',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        gap: 20, padding: 24, textAlign: 'center',
    },
    circle: {
        width: 140, height: 140, borderRadius: '50%',
        background: '#15803d', border: '4px solid #22c55e',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 0 60px rgba(34,197,94,0.5)',
        animation: 'pulse 1.5s ease-in-out infinite',
    },
    title:         { color: '#22c55e', fontSize: 30, fontWeight: 900, margin: 0, letterSpacing: 1 },
    sub:           { color: '#86efac', fontSize: 20, margin: 0 },
    conteneurBox:  { background: '#14532d', borderRadius: 16, padding: '16px 24px', border: '2px solid #16a34a' },
    conteneurLabel: { color: '#4ade80', fontSize: 11, fontWeight: 700, letterSpacing: 2, margin: 0, textTransform: 'uppercase' },
    conteneurNum:  { color: '#fff', fontSize: 24, fontWeight: 900, margin: '8px 0 0', fontFamily: 'monospace', letterSpacing: 2 },
    autoReturn:    { color: '#4ade80', fontSize: 14 },
    btn: {
        background: '#22c55e', border: 'none', borderRadius: 18,
        padding: '22px 32px', color: '#000', fontSize: 18, fontWeight: 900,
        cursor: 'pointer', width: '100%', maxWidth: 360,
        boxShadow: '0 4px 20px rgba(34,197,94,0.4)',
        letterSpacing: 1,
    },
};

export default ConfirmationScreen;
